// VEDNOR SCRIPTS
import gsap from "gsap";

//gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrambleTextPlugin,DrawSVGPlugin, Draggable);

// Modules 
import { navFunc } from './modules/nav';

// Pages 
import { homeFunc } from './pages/home';

(function($, window, document) {
  
  const $body = $('body');
  
  let mm = gsap.matchMedia();
  
  /***************************************************************
    *
    LISTEN FOR JQUERY DOM READY
    *
  ***************************************************************/

  $(function() {
    
    /***************************************************************
      Prevents transitions from animating on initial load
    ***************************************************************/
    
    $body.removeClass("preload");
		
		const classes = document.body.classList;
		let timer = 0;
		window.addEventListener('resize', function () {
				if (timer) {
						clearTimeout(timer);
						timer = null;
				}
				else
						classes.add('preload');

				timer = setTimeout(() => {
						classes.remove('preload');
						timer = null;
				}, 100);
		});
		
		/***************************************************************
      INIT ANIMATION
    ***************************************************************/
	 
		const main = document.querySelector('main');
		
		gsap.set(main, {autoAlpha: 0, y: 40});
		gsap.to(main, {duration: 0.6, autoAlpha: 1, y: 0});

    /***************************************************************
      MODULES
    ***************************************************************/

    navFunc(gsap, mm);
		
		/***************************************************************
      PAGES
    ***************************************************************/
	 
		if ($body.is('.home')) {
			homeFunc(gsap);
		}
		
  });

})(window.jQuery, window, document);